module.exports = __webpack_public_path__ + "static/media/Applications.82d2eff2.svg";